/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_BInputs */



/**
* | output |
* | --- |
* | "Program B" |
*
* @param {Subtitle_Export_Program_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_b = /** @type {((inputs?: Subtitle_Export_Program_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Programme B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программа B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B计划")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムB")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम बी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa B")
	return /** @type {LocalizedString} */ ("Program B")
});